import { render, staticRenderFns } from "./ShopArtPiece.vue?vue&type=template&id=626a0ea5&scoped=true&"
import script from "./ShopArtPiece.vue?vue&type=script&lang=js&"
export * from "./ShopArtPiece.vue?vue&type=script&lang=js&"
import style0 from "./ShopArtPiece.vue?vue&type=style&index=0&id=626a0ea5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626a0ea5",
  null
  
)

export default component.exports